import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";
import { routes } from "@/routes/utils";
import { useNavigate, useParams } from "react-router-dom";
import { useGetQualityChecklistByProject } from "@/services";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui";
import { MoreVertical, Edit } from "lucide-react";

const useQualityChecklist = () => {
  const isMobile = useIsMobile();
  const { id, action } = useParams();
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate();
  const isView = action == routes.view;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const { data: checklist, isLoading: isChecklistLoading } =
    useGetQualityChecklistByProject({ projectId: id as string });

  // Define Table Columns
  const columns = [
    {
      accessorKey: "taskQualityChecklistId",
      header: "ID",
      accessorFn: (row: any) => String(row?.taskQualityChecklistId || ""),
    },
    {
      accessorKey: "title",
      header: "Title",
      cell: (row: any) => {
        return row?.row?.original?.title ? (
          <span
            className="text-secondary border-b-1 border-secondary group-hover:border-secondary cursor-pointer font-[500]"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate(`${row.row?.original.taskQualityChecklistId}/view`);
            }}
          >
            {String(row.row?.original.title)}
          </span>
        ) : (
          <div className="px-3">{""}</div>
        );
      },
    },
    {
      accessorKey: "checklistItemCount",
      header: "#Checklist Items",
      cell: (row: any) => {
        return row?.row?.original?.checklistItemCount ? (
          <span
            className="text-secondary border-b-1 border-secondary group-hover:border-secondary cursor-pointer font-[500]"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate(`${row.row?.original.taskQualityChecklistId}/view`);
            }}
          >
            {String(row.row?.original.checklistItemCount)}
          </span>
        ) : (
          <div className="px-3">{""}</div>
        );
      },
    },
    {
      accessorKey: "description",
      header: "Description",
      accessorFn: (row: any) => String(row?.description || ""),
    },
    ...isView ? [] : [{
      id: "actions",
      header: "Actions",
      cell: (row: any) => (
        <DropdownMenu>
          <DropdownMenuTrigger>
            <MoreVertical className="w-5 h-5 cursor-pointer" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="bg-white border-0 shadow-md"
          >
            <DropdownMenuItem
              className="flex items-center gap-2 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate(`${row.row?.original?.taskQualityChecklistId}/edit`);
              }}
            >
              <Edit className="w-4 h-4" />
              Edit
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ),
    }]
  ];

  const onAdd = () => {
    navigate(`${routes.add}`);
  };

  return {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    isChecklistLoading,
    checklist,
    isView,
  };
};
export default useQualityChecklist;
